import { render, staticRenderFns } from "./myWork.vue?vue&type=template&id=0233d829&scoped=true&"
import script from "./myWork.vue?vue&type=script&lang=js&"
export * from "./myWork.vue?vue&type=script&lang=js&"
import style0 from "./myWork.vue?vue&type=style&index=0&id=0233d829&scoped=true&lang=css&"
import style1 from "./myWork.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0233d829",
  null
  
)

export default component.exports